'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var interfaceDatastore = require('interface-datastore');
var sortKeys = require('sort-keys');
var toString = require('uint8arrays/to-string');
var fromString = require('uint8arrays/from-string');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var sortKeys__default = /*#__PURE__*/_interopDefaultLegacy(sortKeys);

const specKey = new interfaceDatastore.Key('datastore_spec');
function spec(store) {
  return {
    exists() {
      return store.has(specKey);
    },
    async get() {
      const buf = await store.get(specKey);
      return JSON.parse(toString.toString(buf));
    },
    async set(spec) {
      return store.put(specKey, fromString.fromString(JSON.stringify(sortKeys__default["default"](spec, { deep: true }))));
    }
  };
}

exports.spec = spec;
